import { FC, ReactNode } from 'react';

type StickyCtaBarProps = {
  children: ReactNode;
  /** Max-width of the inner content; match the step's content column. */
  maxWidthClass?: string;
};

/**
 * Fixed bottom CTA bar (same pattern as the paywall) so the primary action
 * stays visible on long or short-but-tall steps rather than scrolling off
 * screen. Pages using it should add bottom padding (~pb-28) so their content
 * clears the bar.
 */
const StickyCtaBar: FC<StickyCtaBarProps> = ({
  children,
  maxWidthClass = 'max-w-sm'
}) => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 border-t border-neutral-200 bg-white px-6 pt-3 shadow-[0_-4px_16px_rgba(0,0,0,0.06)]"
    style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
  >
    <div className={`mx-auto w-full ${maxWidthClass}`}>{children}</div>
  </div>
);

export default StickyCtaBar;
